// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 600px) {\r\n  .MuiToolbar-regular {\r\n    min-height: auto !important;\r\n  }\r\n}\r\n", ""]);
